import { FC } from "react";

export interface SideCoverProps {
  backgroundImage: string;
  logo: string;
}

const SideCover: FC<SideCoverProps> = ({ backgroundImage, logo }) => {
  return (
    <div
      data-testid="side-cover"
      className="bg-cover h-100 min-vh-100"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div
        style={{
          backgroundImage: `url(${logo})`,
          backgroundPosition: "50%",
          backgroundRepeat: "no-repeat",
          height: "100%",
        }}
      />
    </div>
  );
};

export default SideCover;
